import { defineMessages } from 'react-intl';

const I18N_NAMESPACE = 'BreezeAddressSearch';

export default defineMessages({
  stepOneTitle: {
    id: `${I18N_NAMESPACE}.stepOneTitle`,
    defaultMessage: "1. Check your roof's potential",
  },
  stepOneBody: {
    id: `${I18N_NAMESPACE}.stepOneBody`,
    defaultMessage:
      'Using our cutting-edge technology, discover the savings solar can offer you with an accurate price quote–without any home visits.',
  },
  stepTwoTitle: {
    id: `${I18N_NAMESPACE}.stepTwoTitle`,
    defaultMessage: '2. Design with our experts',
  },
  stepTwoBody: {
    id: `${I18N_NAMESPACE}.stepTwoBody`,
    defaultMessage:
      'Our team helps you find the best solution for your house and needs. We use only best-in-class hardware, with industry-standard guarantees.',
  },
  stepThreeTitle: {
    id: `${I18N_NAMESPACE}.stepThreeTitle`,
    defaultMessage: '3. Sit back and relax',
  },
  stepThreeBody: {
    id: `${I18N_NAMESPACE}.stepThreeBody`,
    defaultMessage:
      'Our network of vetted expert-installers handles the physical installation. We manage the administrative tasks to ensure you get a hassle-free experience–from start to finish.',
  },
});
